import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import wx from "./modules/wx";
import globalAudio from "./modules/globalAudio";
import globalData from "./modules/globalData";
import baidu from "./modules/baidu"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    wx,
    user,
    globalAudio,
    globalData,
    baidu
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js